module.exports = __webpack_public_path__ + "img/603.8f4be50e.jpg";